export const RequestLocationStatus = Object.freeze({
  // Note: some of these states map to the html5 permissions api
  NOT_LOADING: 'not_loading',
  REQUESTED: 'requested',
  ACCEPTED: 'accepted',
  GRANTED: 'granted',
  DENIED: 'denied',
  LOCATION_RETRIEVED: 'location_retrieved'
})



// WEBPACK FOOTER //
// ./src/services/frontend_statuses.js